import { LOAD_ESCOLAS } from './types'

export const mutations = {
  [LOAD_ESCOLAS] (state, payload) {
    const resposta = Object.assign(state, { escolas: payload })
    state = resposta
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/pesquisa_aulas/mutations.js